import React from "react";

function ErrorPage() {
    return <div>ERROR!</div>;
}

export default ErrorPage;
